import cn from 'classnames';

import React, {useState} from 'react';
import SliderDots from './dots';
import UseSlider from './hooks/useSlider';
import SliderItem from './item';
import './slider.css';
import ImageModal from '../ImageModal';

export interface ISliderData {
  image: string;
  link: string;
  isExternal: boolean;
  guid?: string;
}
interface TSliderProps {
  data?: Array<ISliderData>;
  customClassSlider?: string;
  isBannerHome?: boolean;
}
const CustomCarousel = ({
  data,
  customClassSlider,
  isBannerHome,
}: TSliderProps) => {
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const {currentIndex, onTouchEnd, onTouchMove, onTouchStart, setCurrentIndex} =
    UseSlider(data?.length ? data?.length - 1 : 0);
  const imagesUrl = data?.map(item => item.image);

  return (
    <div>
      <div
        className={cn('customSlider', customClassSlider)}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onClick={() => setIsImageModalOpen(true)}
      >
        {data && data.length > 0 ? (
          data?.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <SliderItem
                  currentIndex={currentIndex}
                  dataItem={item}
                  isBannerHome={isBannerHome}
                />
              </React.Fragment>
            );
          })
        ) : (
          <div
            className={'slide-item'}
            style={{transform: `translate(-${currentIndex * 100}%)`}}
          >
            <div className="bg-gray-50 w-full h-full flex text-[50px] text-[#D0D5DD] items-center justify-center">
              <img
                alt="default image"
                className="object-contain w-full min-w-full h-full rounded-lg aspect-square"
                src="https://s3.ir-thr-at1.arvanstorage.ir/shop-advertisement/empty_card_image.svg"
              />
            </div>
          </div>
        )}
      </div>
      {imagesUrl && !isBannerHome && (
        <ImageModal
          images={imagesUrl}
          isOpen={isImageModalOpen}
          setIsOpen={setIsImageModalOpen}
        />
      )}
      {data && (
        <SliderDots
          currentIndex={currentIndex}
          images={data.map(item => item.image)}
          setCurrentIndex={setCurrentIndex}
        />
      )}
    </div>
  );
};

export default CustomCarousel;
